export default __webpack_public_path__ + "static/media/info-blue.ffb94aa6.svg";